module.exports = __webpack_public_path__ + "static/img/custom-empty-image.c6a58402.png";